<template>
  <div>
    <variables :resourceTempId="id"></variables>

    <tasks class="mt-10" :resourceTempId="id"></tasks>

    <instances class="mt-10" :resourceTempId="id"></instances>
  </div>
</template>

<script>
import Variables from "./Variables";
import Tasks from "./Tasks";
import Instances from './Instances';

export default {
  name: "ResourceWindow",
  components: { Variables, Tasks, Instances },
  props: ["id"]
};
</script>
